import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';

import { useFormReadOnly } from '../../../../common';
import { DischargeCriteriaSection, DischargeReasonsSection } from './components';
import { useFetchTreatmentPlanV3DischargePage, useTreatmentPlanV3Discharge } from './hooks';
import { TreatmentPlanV3PageContent } from '../components';

export default function DischargeForm() {
  const { retry } = useFetchTreatmentPlanV3DischargePage();
  const {
    dischargePage,
    dischargePageLoadCount,
    reasons,
    isLoading,
    hasLoadError,
    isUpdatingCriteria,
    isSavingReason,
    updateCriteria,
    createReason,
    deleteReason,
  } = useTreatmentPlanV3Discharge();
  const readOnly = useFormReadOnly();

  let pageBody;
  if (dischargePage !== null) {
    pageBody = (
      <>
        <DischargeCriteriaSection
          key={dischargePageLoadCount}
          disabled={isLoading || readOnly}
          dischargePage={dischargePage}
          isUpdating={isUpdatingCriteria}
          onUpdate={updateCriteria}
        />
        <DischargeReasonsSection
          reasons={reasons}
          disabled={isLoading || isSavingReason || readOnly}
          isSaving={isSavingReason}
          onCreate={createReason}
          onDelete={deleteReason}
        />
      </>
    );
  } else if (hasLoadError) {
    pageBody = (
      <Stack gap={1} alignItems="flex-start">
        <Typography>Unable to load discharge information. Please try again.</Typography>
        <Button onClick={retry} variant="contained">
          Retry
        </Button>
      </Stack>
    );
  } else {
    pageBody = (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  return (
    <TreatmentPlanV3PageContent title="Transition plan and discharge criteria">
      {pageBody}
    </TreatmentPlanV3PageContent>
  );
}
